<script setup lang="ts">
import { PButton, PInput } from '@pokerly/ui';
import { nextTick, onMounted, ref, useTemplateRef } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { useRoundsStore } from '@/stores/rounds-store.ts';
import CircleXIcon from '@/assets/icons/CircleXIcon.vue';

const inputRef = useTemplateRef('searchInput');
const searchText = ref('');
const emit = defineEmits<{
    cancelSearchClick: [];
}>();

const roundsStore = useRoundsStore();
onMounted(() => {
    nextTick(() => {
        inputRef.value?.inputEl?.focus();
    });
});

const triggerSearch = useDebounceFn(async (value: string) => {
    await roundsStore.search(value);
}, 500);

function onSearchTextUpdated(value: string | number) {
    searchText.value = String(value);
    triggerSearch(searchText.value);
}
</script>

<template>
    <div class="w-full min-h-12.5 flex items-center gap-2 px-2 py-1 border-border border-l-2">
        <div class="relative grow">
            <PInput
                ref="searchInput"
                class="pr-10"
                size="lg"
                :model-value="searchText"
                @update:model-value="onSearchTextUpdated"
            />
            <PButton
                class="absolute end-0 inset-y-0 flex items-center justify-center my-auto mr-1"
                @click="onSearchTextUpdated('')"
                variant="ghost"
                size="sm"
            >
                <CircleXIcon />
            </PButton>
        </div>

        <PButton variant="outline" size="lg" @click="emit('cancelSearchClick')"> Cancel </PButton>
    </div>
</template>
